<div
  *ngIf="!loading"
  class="pt-3 pb-2">
  <crm-table-bank-details
    #tableBankDetailsComponent
    [withCard]="false"
    [(bankDetails)]="bankDetails"
    [banks]="banks"
    [jurisdiction]="jurisdiction"
    [showDefaultBankDetail]="showDefaultBankDetail"
    [showPaymentsViaBank]="true"
    (bankSearch)="searchBank($event)"></crm-table-bank-details>

  <div
    *ngIf="errors?.length"
    class="mb-3">
    <small class="p-error">
      {{ errors | join }}
    </small>
  </div>

  <div class="flex justify-content-between flex-wrap gap-3 pt-5">
    <crm-button
      [disabled]="!bankDetails.length"
      type="button"
      label="Сохранить"
      icon="pi pi-check"
      styleClass="p-button-success"
      (onClick)="saveBankDetails()"></crm-button>

    <crm-button
      type="button"
      label="Добавить реквизит"
      icon="pi pi-plus"
      styleClass="p-button-text p-button-success"
      (onClick)="addBankDetail()"></crm-button>
  </div>
</div>

<crm-spinner
  *ngIf="loading"
  top="mt-4"></crm-spinner>
